import { Loader } from '@pwskills/rachnaui';
import React from 'react';

type Props = {
  open: boolean;
};

type DialogProps = {
  open: boolean;
  children: React.ReactNode;
  title?: string;
  className?: string;
};

const Dialog = ({ open, children, title, className = '' }: DialogProps) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className={`bg-white rounded-lg shadow-xl p-6 max-w-lg w-full ${className}`}>
        {title && (
          <div className="border-b pb-4 mb-4">
            <h2 className="text-lg font-semibold text-center">{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

const NsdcEnrolmentLoader = ({ open }: Props) => {
  return (
    <section className="bg-white text-center">
      <Dialog
        open={open}
        title="Please wait... Creating accessing to course "
        className="!max-w-[600px]"
      >
        <Loader className="m-auto mt-6" />
      </Dialog>
    </section>
  );
};

export default NsdcEnrolmentLoader;
